import React from 'react';
import AcumenValuesExperienceTips from './acumen-values-experience-tips';
import { REPORT_TYPE } from '../../../../utils/constants';

function PagedAcumenValuesExperienceTips({
  candidate,
  valuesTips,
  creatingPdf,
  topFourMisAligned = false,
  withAcumen = true,
  remoteStaffing = false,
  reportType = REPORT_TYPE.coaching,
}) {
  return (
    <>
      {!creatingPdf ? (
        <div className="print-page">
          <AcumenValuesExperienceTips
            candidate={candidate}
            withAcumen={withAcumen}
            topFourMisAligned={topFourMisAligned}
            valuesTips={valuesTips}
            reportType={reportType}
            remoteStaffing={remoteStaffing}
          />
        </div>
      ) : (
        <>
          <div className="print-page">
            <AcumenValuesExperienceTips
              candidate={candidate}
              singlePage={false}
              withAcumen={withAcumen}
              topFourMisAligned={topFourMisAligned}
              valuesTips={valuesTips}
              reportType={reportType}
              remoteStaffing={remoteStaffing}
            />
          </div>
          <div className="print-page">
            <AcumenValuesExperienceTips
              candidate={candidate}
              withAcumen={false}
              singlePage={false}
              topFourMisAligned={topFourMisAligned}
              valuesTips={valuesTips}
              reportType={reportType}
              remoteStaffing={remoteStaffing}
            />
          </div>
          <div className="print-page">
            <AcumenValuesExperienceTips
              candidate={candidate}
              withAcumen={false}
              withValues={false}
              singlePage={false}
              topFourMisAligned={topFourMisAligned}
              valuesTips={valuesTips}
              reportType={reportType}
              remoteStaffing={remoteStaffing}
            />
          </div>
        </>
      )}
    </>
  );
}

export default PagedAcumenValuesExperienceTips;
